'use strict'

require('@rails/ujs').start()
require('@rails/activestorage').start()
require("turbolinks").start()
require('./channels')